export default {
    SuperAdmin: 'SysteemAdmin',
    DataManager: 'DataManager'
}
